/**
 * ## Filter Tab Controller
 *
 * @module src/controllers/filter
 */

"use strict";

const block = require("../../components/block");
const l = require("../../common").localization;

/** Init
 */
const init = (kd) => {
  kd.on("chart.update", (data) => {
    tableStatus(kd);
  });
  tableStatus(kd);
};

const tableStatus = (kd) => {
  // standard setup
  const opt = {
    kd,
    targetDiv: "content_standard_filter",
  };

  const data = {
    type: "filter",
    domain: "template",
    h1: "All Parties",
    h2: "...",
    expand: true,
    single: false,
    group: "all",
    refresh: 30,
    height: {},
    status: {
      min: 1,
      max: 8,
    },
    size: {
      min: 1,
      max: 500,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  const buttons = [];
  data.tableStatus = Object.assign([], kd.doc("location")[0].tableStatus);
  data.tableStatus.unshift({
    description: l.translate("No Filter"),
    value: 0,
  });

  block.create(opt, data, (err, result) => {
    kd.localstore.data.chart_status_filter = result.value;
    kd.emit("chart.update", {});
  });
};

module.exports = {
  init,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/filter/index.js
 **/